import {
  apiPost,
  buildFilterString,
  buildSearchString,
} from "../../../common/services/ApiClient";
import { KeyValue } from "../../../interfaces";

//combines data if provided key matches another object key in the array
export const combineStateData = (data: KeyValue[], key: string) => {
  let allDataCombined: KeyValue = {};
  data.forEach((val: KeyValue) => {
    allDataCombined = {
      ...allDataCombined,
      [val[key]]: {
        ...val,
        count: allDataCombined[val[key]]
          ? val.count + allDataCombined[val[key]].count
          : val.count,
        unique_count: allDataCombined[val[key]]
          ? val.unique_count + allDataCombined[val[key]].unique_count
          : val.unique_count,
        sum_DEPSUMBR: allDataCombined[val[key]]
          ? val.sum_DEPSUMBR + allDataCombined[val[key]].sum_DEPSUMBR
          : val.sum_DEPSUMBR,
      },
    };
  });
  const dataKeys = Object.keys(allDataCombined).filter(data => data);
  return dataKeys.map(key => allDataCombined[key]);
};

//gets totals for marketSelect
export const getMarketSelectTotals = (resp: KeyValue[], index: number) => {
  let totals = { total: 0, sum_DEPSUMBR: 0, count: 0 };
  //gets all of the totals object for each column (Commercial, Savings, Foreign)
  const arrayOfTotals = resp.map((val: KeyValue) => val[index].totals);
  const institutionCount: string[] = [];
  arrayOfTotals.forEach((val: KeyValue) => {
    //if the totals arent empty it goes over each object to sum the values
    if (val.count) {
      let branchCount = 0;
      Object.keys(val).forEach((key: string) => {
        //finds the matching cert keys from each total object (Needs the terms:["CERT"] set in the api call)
        const keyVal = key.match(/^count_CERT_/);
        if (keyVal && keyVal.input) {
          //if the key is unique, it pushes it to the institution count array
          !institutionCount.includes(keyVal.input) &&
            institutionCount.push(keyVal.input);
          //sums up the value for each cert count
          branchCount = branchCount + val[keyVal.input];
        }
      });
      //returns the new object with the summations for each value
      return (totals = {
        total: totals.total + branchCount,
        count: institutionCount.length,
        sum_DEPSUMBR: val.sum_DEPSUMBR
          ? totals.sum_DEPSUMBR + val.sum_DEPSUMBR
          : totals.sum_DEPSUMBR,
      });
    }
  });
  return totals;
};

//gets the total values based off of each aggregated value in the data
export const getBranchCount = (data: KeyValue[]) => {
  let branch = 0;
  data.forEach((val: KeyValue) => {
    branch = branch + val.count;
  });
  return branch;
};

//filters row to place correct data in the corresponding row
export const filterDataForRow = (
  key: string,
  currentData: KeyValue[],
  allData: KeyValue,
) => {
  const options = currentData.map(data => data[key]);
  return allData.map((res: KeyValue, index: number) => {
    return options.includes(res[key])
      ? currentData.filter(data => data[key])[options.indexOf(res[key])]
      : { count: 0, unique_count: 0, sum_DEPSUM: 0 };
  });
};

export default function generateBranchOfficeDepositsApiUrl(
  appState: KeyValue,
  aggregations?: {
    by: string;
    limit?: number;
    terms?: string[];
    sum?: string[];
  },
  state?: string,
  marketSelections?: KeyValue | KeyValue[],
  getUnique?: string,
  additionalFilters?: string,
  sortBy?: string,
  sortOrder?: string,
  outOfMarketSelections?: boolean,
  offset?: number,
) {
  const aggBy = aggregations ? aggregations.by : "";

  const aggTerms =
    aggregations && aggregations.terms ? aggregations.terms.join(",") : "";

  const aggSumFields =
    aggregations && aggregations.sum ? aggregations.sum.join(",") : "";

  const aggLimit = aggregations && aggregations.limit ? aggregations.limit : "";

  const marketSelectState =
    state && state?.toLowerCase() !== "all" ? ` AND STALPBR:"${state}"` : "";
  let marketSelectCounties = "";
  let marketSelectCities = "";
  let marketSelectZips = "";
  if (marketSelections && Array.isArray(marketSelections)) {
    if (
      marketSelections[0].cities &&
      marketSelections[0].cities[0] &&
      marketSelections[0].cities[0]?.toLowerCase() !== "all"
    ) {
      const allCities = [].concat.apply(
        [],
        appState.ui.marketSelection.map(
          (selections: KeyValue) => selections.cities,
        ),
      );
      marketSelectCities = ` AND CITY2BR:(${allCities
        .map((city: string) => `"${city}"`)
        .join(" OR ")})`;
    }
    if (
      appState.ui.marketSelection[0].zips &&
      appState.ui.marketSelection[0].zips[0] &&
      appState.ui.marketSelection[0].zips[0]?.toLowerCase() !== "all"
    ) {
      const allCities = [].concat.apply(
        [],
        appState.ui.marketSelection.map(
          (selections: KeyValue) => selections.zips,
        ),
      );

      marketSelectZips = ` AND ZIPBR:(${allCities.join(" OR ")})`;
    }
  } else if (outOfMarketSelections && marketSelections) {
    //sets state
    if (
      state &&
      state?.toLowerCase() !== "all" &&
      marketSelections?.counties[0] &&
      marketSelections?.counties[0]?.toLowerCase() !== "all" &&
      marketSelections?.cities[0]?.toLowerCase() === "all" &&
      marketSelections?.zips[0]?.toLowerCase() === "all"
    ) {
      marketSelectCounties = ` AND !CNTYNAMB:(${marketSelections?.counties
        .map((county: string) => `"${county}"`)
        .join(" OR ")})`;
    }
    if (
      state &&
      state?.toLowerCase() !== "all" &&
      marketSelections?.cities[0] &&
      marketSelections?.cities[0]?.toLowerCase() !== "all" &&
      marketSelections?.zips[0]?.toLowerCase() === "all"
    ) {
      marketSelectCities = ` AND !CITY2BR:(${marketSelections?.cities
        .map((city: string) => `"${city}"`)
        .join(" OR ")})`;
    }
    if (
      state &&
      state.toLowerCase() !== "all" &&
      marketSelections?.zips[0] &&
      marketSelections?.zips[0]?.toLowerCase() !== "all"
    ) {
      marketSelectZips = ` AND !ZIPBR:(${marketSelections?.zips.join(" OR ")})`;
    }
  } else {
    marketSelectCounties =
      marketSelections &&
      marketSelections.counties &&
      marketSelections.counties[0] &&
      marketSelections.counties[0]?.toLowerCase() !== "all"
        ? ` AND CNTYNAMB:(${marketSelections.counties
            .map((county: string) => `"${county}"`)
            .join(" OR ")})`
        : "";

    marketSelectCities =
      marketSelections &&
      marketSelections.cities &&
      marketSelections.counties[0] &&
      marketSelections.cities[0]?.toLowerCase() !== "all"
        ? ` AND CITY2BR:(${marketSelections.cities
            .map((city: string) => `"${city}"`)
            .join(" OR ")})`
        : "";

    marketSelectZips =
      marketSelections &&
      marketSelections.zips &&
      marketSelections.zips[0] &&
      marketSelections.zips[0]?.toLowerCase() !== "all"
        ? ` AND ZIPBR:(${marketSelections.zips.join(" OR ")})`
        : "";
  }

  const moreFilters = additionalFilters ? ` AND ${additionalFilters}` : "";

  if (
    appState.filters.stalpbr &&
    appState.filters.stalpbr?.toLowerCase() === "all"
  ) {
    appState.filters.stalpbr = "";
  }

  const branchOfficePost = apiPost({
    limit: 10000,
    offset: offset ? offset * 10000 : 0,
    filters: `${buildFilterString(
      appState.filters,
    )}${marketSelectState}${marketSelectCounties}${marketSelectCities}${marketSelectZips}${moreFilters}`,
    search: `${buildSearchString(appState.search)}`,
    agg_by: aggBy,
    agg_term_fields: aggTerms,
    agg_sum_fields: aggSumFields,
    agg_limit: aggLimit,
    get_unique: getUnique,
    sort_by: sortBy,
    sort_order: sortOrder,
  });
  return branchOfficePost;
}
